//路由守卫
import router from './router'
import store from './store'
import {getToken} from '@/utils/setCooKies'

router.beforeEach((to, from, next) => {
    if (getToken()) {
        if (to.path == "/goodsSearch" || to.path == "/detailsIndex") {
            store.dispatch('getCollectArr').then(() => {
                next();
            })
        } else if (to.path == '/center/personal') {
            //更新用户信息
            store.dispatch('getUsetInfo').then(() => {
                next();
            })
        } else {
            next();
        }
    } else {
        if (to.meta.isNOlog) {
            next({path: '/auto'})
        } else {
            next()
        }
    }
    if (to.meta.title) {
        document.title = to.meta.title
    } else {
        document.title = '安之联工业品超市'
    }
})

router.afterEach(() => {
//   NProgress.done() // 结束Progress
})


// WEBPACK FOOTER //
// ./src/routeGuard.js